export var CursorType;
(function (CursorType) {
    CursorType["Ticketing"] = "Ticketing";
    CursorType["Organization"] = "Organization";
})(CursorType || (CursorType = {}));
